//
//  exporter-utils.ts
//  Supernova CLI
//
//  Created by Jiri Trecak.
//  Copyright © Supernova.io. All rights reserved.
//

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports

import * as pulsar from "@supernova-studio/pulsar-language"

import { apiUrlForEnvironment, ExportConfiguration, TargetEnv } from "../../types/index.js"

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Utils

export function exportConfiguration(setup: {
  apiKey: string
  brandId?: string
  dsId: string
  environment: TargetEnv
  exportPath: string
  logger: pulsar.PLLogger
  proxyUrl?: string
  themeId?: string
  versionId: string
}): ExportConfiguration {
  return {
    accessToken: setup.apiKey,
    apiUrl: `${apiUrlForEnvironment(setup.environment, undefined)}`,
    apiVersion: "0.2",
    brandId: setup.brandId,
    designSystemId: setup.dsId,
    designSystemVersionId: setup.versionId,
    exportPath: setup.exportPath,
    logger: setup.logger,
    proxyUrl: setup.proxyUrl,
    themeId: setup.themeId,
  }
}
